<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Cadastro de Clientes
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>

      <div>
        <p></p>
        <q-btn
          class="q-mt-sm"
          label="Criar"
          color="primary"
          no-caps
          icon="add"
          @click="rightDrawerOpen = true"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Todos os Clientes Cadastrados
        </span>
      </div>
      <q-table
        :columns="columns"
        :loading="loading"
        dense
        :rows="listaClientes"
        color="primary"
        class="tabela-tamanho-fixo my-sticky-dynamic"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-pagination
        :rows-per-page-options="[0]"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:body-cell-id_cliente="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.id_cliente
            }}</span>
            <q-input
              v-else
              v-model="props.row.id_cliente"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>

        <template v-slot:body-cell-id_vendor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.id_vendor
            }}</span>
            <q-input
              v-else
              v-model="props.row.id_vendor"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>

        <template v-slot:body-cell-id_plano_pagamento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.id_plano_pagamento
            }}</span>
            <q-input
              v-else
              v-model="props.row.id_plano_pagamento"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>
        <template v-slot:body-cell-tipo_venda="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.tipo_venda
            }}</span>
            <q-input
              v-else
              v-model="props.row.tipo_venda"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>
        <template v-slot:body-cell-codigo_filial="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.codigo_filial
            }}</span>
            <q-input
              v-else
              v-model="props.row.codigo_filial"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>
        <template v-slot:body-cell-codigo_praca="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{
              props.row.codigo_praca
            }}</span>
            <q-input
              v-else
              v-model="props.row.codigo_praca"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.editar != true">{{ props.row.status }}</span>
            <q-input
              v-else
              v-model="props.row.status"
              class="input"
              dense
              outlined
            />
          </q-td>
        </template>

        <template v-slot:body-cell-delete="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              :disable="props.row.editar == true"
              round
              color="red"
              flat
              icon="delete"
              @click="excluirCliente(props.row.id)"
            />
          </q-td>
        </template>

        <template v-slot:body-cell-editar="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              v-if="props.row.editar != true"
              round
              color="brand-1"
              flat
              icon="edit"
              @click="props.row.editar = true"
            />
            <q-btn
              v-if="props.row.editar == true"
              round
              color="positive"
              flat
              icon="done"
              @click="editarCliente(props.row), (props.row.editar = undefined)"
            />

            <q-btn
              v-if="props.row.editar == true"
              round
              color="negative"
              flat
              icon="close"
              @click="props.row.editar = undefined"
            />
          </q-td>
        </template>
      </q-table>
      <!--<div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>-->
    </div>
    <ModalLateral
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Cadastrar Cliente'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Codigo de Filial</div>
          <q-input v-model="dadosCriacao.filial" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Tipo Venda</div>
          <q-input
            v-model="dadosCriacao.tipoVenda"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Codigo Praça</div>
          <q-input
            v-model="dadosCriacao.codigoPraca"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Plano de Pagamento</div>
          <q-input
            v-model="dadosCriacao.planoPagamento"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Cliente Id</div>
          <q-input
            v-model="dadosCriacao.cliente"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Unidade Id</div>
          <q-input
            v-model="dadosCriacao.unidade"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Status</div>
          <q-input v-model="dadosCriacao.status" class="input" dense outlined />
        </div>
      </template>
      <template v-slot:botao-modal>
        <div class="row col-12 q-gutter-sm">
          <q-btn
            no-caps
            label="Criar"
            class="btn-modal"
            icon="add"
            color="positive"
            @click="criarClientes"
          />
        </div>
      </template>
    </ModalLateral>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ModalLateral from "../components/ModalLateral.vue";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "id_cliente",
    label: "Cliente Id",
    field: "id_cliente",
    align: "left",
  },
  {
    name: "id_vendor",
    label: "Unidade",
    field: "id_vendor",
    align: "left",
  },
  {
    name: "id_plano_pagamento",
    label: "Plano Pagamento",
    field: "id_plano_pagamento",
    align: "left",
  },
  {
    name: "codigo_filial",
    label: "Codigo Filial",
    field: "codigo_filial",
    align: "left",
  },
  {
    name: "codigo_praca",
    label: "Codigo Praça",
    field: "codigo_praca",
    align: "left",
  },

  {
    name: "created_at",
    label: "Data de Criação",
    field: (row) =>
      row.created_at != null
        ? row.created_at.split(" ")[0].split("-").reverse().join("/")
        : "Sem Data",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: (row) => row.status,
    align: "left",
  },
  {
    name: "tipo_venda",
    label: "Tipo de Venda",
    field: (row) => row.tipo_venda,
    align: "left",
  },

  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },
  {
    name: "delete",
    label: "Excluir",
    field: "delete",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect, ModalLateral },
  setup() {
    const store = useStore();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const rightDrawerOpen = ref(false);
    const listaClientes = ref([]);
    const quasar = useQuasar();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 50,
    });
    let loading = ref(false);
    let disable = ref(false);
    const dadosCriacao = ref({
      filial: "",
      tipoVenda: "",
      codigoPraca: "",
      planoPagamento: "",
      status: "",
      cliente: "",
      unidade: "",
    });
    const filtros = ref({
      nome: "",
      matricula: "",
      unidade: "",
    });

    const listarClientes = async (page = 0, rowsNumber = 10) => {
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("integracao/listarClientes", {
          per_page: rowsNumber,
          page: page,
          nome: filtros.value.nome,
          matricula: filtros.value.matricula,
          id_vendor: 1,
        });

        listaClientes.value = response.data.data;
        // pagination.value.rowsPerPage = response.data.results.per_page;
        //pagination.value.page = response.data.results.current_page;
        //pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        loading.value = false;
        disable.value = false;
        console.log(error);
      }
    };

    const paginarTabela = async () => {
      listarClientes(pagination.value.page, pagination.value.rowsPerPage);
    };

    const excluirCliente = async (id) => {
      loading.value = true;
      disable.value = true;
      try {
        await store.dispatch("integracao/excluirCliente", {
          id: id,
        });

        quasar.notify({
          message: "Cliente excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarClientes();
        loading.value = false;
        disable.value = false;
      } catch (error) {
        loading.value = false;
        disable.value = false;
        quasar.notify({
          message: "Erro a o excluir cliente.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarCliente = async (row) => {
      loading.value = true;
      disable.value = true;
      try {
        await store.dispatch("integracao/editarCliente", {
          id_vendor: row.id_vendor,
          id_cliente: row.id_cliente,
          id_plano_pagamento: row.id_plano_pagamento,
          tipo_venda: row.tipo_venda,
          codigo_filial: row.codigo_filial,
          codigo_praca: row.codigo_praca,

          status: row.status,
          id: row.id,
        });

        quasar.notify({
          message: "Cliente editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarClientes();
        loading.value = false;
        disable.value = false;
      } catch (error) {
        loading.value = false;
        disable.value = false;
        quasar.notify({
          message: "Erro a o editar cliente.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarClientes = async () => {
      try {
        loading.value = true;
        disable.value = true;
        await store.dispatch("integracao/criarCliente", {
          tipo_venda: dadosCriacao.value.tipoVenda,
          codigo_filial: dadosCriacao.value.filial,
          codigo_praca: dadosCriacao.value.codigoPraca,
          id_plano_pagamento: dadosCriacao.value.planoPagamento,
          id_cliente: dadosCriacao.value.cliente,
          id_vendor: dadosCriacao.value.unidade,
          status: dadosCriacao.value.status,
        });

        quasar.notify({
          message: "Cliente criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
        disable.value = false;
        rightDrawerOpen.value = false;

        dadosCriacao.value = {
          filial: "",
          tipoVenda: "",
          codigoPraca: "",
          planoPagamento: "",
          status: "",
          cliente: "",
          unidade: "",
        };
        listarClientes();
      } catch (error) {
        loading.value = false;
        disable.value = false;
        console.log(error);
        quasar.notify({
          message: "Erro a o criar cliente.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarClientes();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarClientes(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarClientes);

    return {
      columns,
      unidade,
      listarClientes,
      listaClientes,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      paginarTabela,
      filtros,
      excluirCliente,
      criarClientes,
      rightDrawerOpen,
      dadosCriacao,
      editarCliente,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 0;
}
.my-sticky-dynamic {
  max-height: 600px;
}
thead tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .input-codigo-epi-grid {
    width: 70px;
    outline: none;
  }
}
</style>
